import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb, Badge } from 'react-bootstrap';
import ScheduleListView from './list/index';
import ScheduleView from './schedule/index';
import Navigation from 'context/nav';
import { withPreferences } from 'context/preferences';

class SchedulerSchedulesShell extends Component {
  /**
   * Routes:
   *
   * - /:orgId/:blobId/schedules
   *   Entry point, renders the list of schedules
   *
   * - /:orgId/:blobId/schedules/:scheduleId
   *   Renders schedule details and list of executions
   */

  onClick(event, path) {
    event.preventDefault();
    this.props.history.push(path);
  }

  render() {
    const orgId = this.props.match.params.orgId;
    const blobId = this.props.match.params.blobId;
    const section = this.props.match.params.section;
    const scheduleId = ( "schedules" == section ) ? this.props.match.params.sectionId : null;

    const canEditRevision = this.props.app.api.canUpdateRevision(this.props.blob, this.props.revision);
    const timezone = this.props.preferences["app.timezone"];

    const rootLink = ( scheduleId ? true : false );

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col>
              <Breadcrumb style={{
                marginBottom: "-4px"
              }}>
                <Breadcrumb.Item
                  onClick={(event) => {
                    this.onClick(event, Navigation.schedulerPath(orgId, blobId, "schedules"))
                  }}
                  active={!rootLink}>
                  Schedules
                </Breadcrumb.Item>
                {scheduleId &&
                  <Breadcrumb.Item active={true}>
                    Schedule&nbsp;&nbsp;
                    <Badge bg="info" className="title-tag-badge">{scheduleId}</Badge>
                  </Breadcrumb.Item>
                }
              </Breadcrumb>
            </Col>
          </Row>
        </Container>

        {!scheduleId &&
          <ScheduleListView
            app={this.props.app}
            blob={this.props.blob}
            revision={this.props.revision}
            canEditRevision={canEditRevision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            timezone={timezone}
          />
        }
        {( "schedules" === section && scheduleId ) &&
          <ScheduleView
            app={this.props.app}
            blob={this.props.blob}
            revision={this.props.revision}
            canEditRevision={canEditRevision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
            timezone={timezone}
          />
        }
      </>
    );
  }
}

export default withPreferences(SchedulerSchedulesShell, ["app.timezone"],
  props => ({ orgId: props.org.id, blobId: props.blob.id }));
